import type { ThemeButton } from '@sites/site-theme/src/types/theme-button.type';

import { EButtonHoverType, EButtonStyleType } from '@common/enums';
import { TRANSPARENT_COLOR } from '@sites/site-theme/src/config/colors.const';

import { ThemeColorNames } from '@sites/site-theme/src/enums/color-names.enum';
import { ThemeCssUnit } from '@sites/site-theme/src/enums/css.enum';

export const DEFAULT_BUTTON_PRESETS: Array<Array<ThemeButton>> = [
    // -------------------Group 1------------------------------//
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
                borderRadius: { value: 8, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.secondary],
                borderColor: [ThemeColorNames.secondary],
                borderRadius: { value: 8, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.secondary],
                borderColor: [ThemeColorNames.secondary],
            },
        },
    ],
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
                borderRadius: { value: 0, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.secondary],
                borderColor: [ThemeColorNames.secondary],
                borderRadius: { value: 0, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.secondary],
                borderColor: [ThemeColorNames.secondary],
            },
        },
    ],
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
                borderRadius: { value: 50, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.secondary],
                borderColor: [ThemeColorNames.secondary],
                borderRadius: { value: 50, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.secondary],
                borderColor: [ThemeColorNames.secondary],
            },
        },
    ],
    // -------------------Group 2------------------------------//
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
                borderRadius: { value: 8, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
                borderRadius: { value: 8, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
            },
        },
    ],
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
                borderRadius: { value: 0, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
                borderRadius: { value: 0, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
            },
        },
    ],
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
                borderRadius: { value: 50, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.light],
                background: [ThemeColorNames.primary],
                borderColor: [TRANSPARENT_COLOR],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
                borderRadius: { value: 50, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
            },
        },
    ],
    // -------------------Group 3------------------------------//
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
                borderRadius: { value: 8, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.secondary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.secondary],
                borderRadius: { value: 8, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.secondary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.secondary],
            },
        },
    ],
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
                borderRadius: { value: 0, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.secondary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.secondary],
                borderRadius: { value: 0, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.secondary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.secondary],
            },
        },
    ],
    [
        {
            // primary
            styleType: EButtonStyleType.primary,
            base: {
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
                borderRadius: { value: 50, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.primary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.primary],
            },
        },
        {
            // secondary
            styleType: EButtonStyleType.secondary,
            base: {
                color: [ThemeColorNames.secondary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.secondary],
                borderRadius: { value: 50, unit: ThemeCssUnit.px },
                borderStyle: 'solid',
                borderWidth: { value: 2, unit: ThemeCssUnit.px },
            },
            hover: {
                hoverType: EButtonHoverType.opacity,
                opacity: 80,
                shadow: 'none',
                color: [ThemeColorNames.secondary],
                background: [TRANSPARENT_COLOR],
                borderColor: [ThemeColorNames.secondary],
            },
        },
    ],
];
